import { Routes } from '@angular/router';
import { tokenGuard, authGuard, projectAuthGuard } from './utils/guards';

export const routeConfig: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginPage),
    canActivate: [tokenGuard],
  },
  {
    path: 'account',
    loadComponent: () =>
      import('./account/client-account.page').then((m) => m.ClientAccountPage),
    canActivate: [authGuard],
    pathMatch: 'full',
  },
  {
    path: ':projectid',
    loadComponent: () =>
      import('./home/client-home.page').then((m) => m.ClientHomePage),
    canActivate: [projectAuthGuard],
  },
  {
    path: ':projectid/list/:listid',
    loadComponent: () =>
      import('./list/client-list.page').then((m) => m.ClientListPage),
    canActivate: [projectAuthGuard],
  },
  { path: 'client/:projectid', redirectTo: ':projectid' },
  {
    path: '**',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (m) => m.PageNotFound
      ),
  },
];
